import { render } from "./CabCard.vue?vue&type=template&id=0bdb5b7e&scoped=true"
import script from "./CabCard.vue?vue&type=script&lang=js"
export * from "./CabCard.vue?vue&type=script&lang=js"

import "./CabCard.vue?vue&type=style&index=0&id=0bdb5b7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdb5b7e"]])

export default __exports__